export default {
  SUPSTER_SUPPORT_EMAIL: 'info@supster.me',
}
